import { localStorage } from '@tunein/web-utils';
const PLAYER_SETTINGS_STORAGE_KEY = 'playerSettings';
export default class PlayerSettingsStorage {
    get() {
        return localStorage.get(PLAYER_SETTINGS_STORAGE_KEY);
    }
    set(settingsData) {
        const existingSettingsData = this.get();
        const newSettingsData = {
            ...existingSettingsData,
            ...settingsData,
        };
        localStorage.set(PLAYER_SETTINGS_STORAGE_KEY, newSettingsData);
    }
}
